// BTB: keep the "Colour: <value>" legend in sync with the selected swatch.
// Listens at document level (event delegation) so it survives variant-change
// section re-renders without needing per-picker re-binding.
(function () {
  function updateLabelFor(input) {
    if (!input || input.type !== 'radio' || !input.checked) return;
    var fieldset = input.closest('.product-form__input--swatch');
    if (!fieldset) return;
    var current = fieldset.querySelector('[data-swatch-current]');
    if (current) current.textContent = input.value;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    if (!t.closest('.product-form__input--swatch')) return;
    updateLabelFor(t);
  });
})();
